import { queryOptions, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetResponsesDistributionResponseDataSchema, TimeFrame } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetResponsesDistributionResponseDataSchema>>

type Props = {
  timeFrame: TimeFrame
  campaignId?: string
  goalId: string
}

export const PredefinedResponsesDistributionQuery = ({ timeFrame, campaignId, goalId }: Props) => {
  const queryClient = useQueryClient()
  const queryKey = ["responsesDistribution", timeFrame, campaignId, goalId]

  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/responses-distribution`, {
        params: { timeFrame, campaignId, goalId },
      })

      if (
        response.data.data.distribution.at(0) &&
        !response.data.data.distribution.at(0)?.optionValue
      ) {
        setTimeout(() => {
          queryClient.invalidateQueries({ queryKey })
        }, 2000)
      }

      return response.data
    },
  })
}
